import { all, fork } from 'redux-saga/effects';

import chatMessages from './chatMessages';
import pubnub from './pubnub';
import sendChat from './sendChat';
import rejectTutor from './rejectTutor';
import selectQuestion from './selectQuestion';
import startSession from './startSession';
import endSession from './endSession';
import cancelQuestion from './cancelQuestion';
import tutorStatistic from './tutorStatic';
import answerStage from './answerStage';
import chatModal from './chatModal';
import tagging from './tagging';

export default function* () {
  yield all([
    fork(chatMessages),
    fork(pubnub),
    fork(sendChat),
    fork(rejectTutor),
    fork(selectQuestion),
    fork(startSession),
    fork(endSession),
    fork(cancelQuestion),
    fork(tutorStatistic),
    fork(answerStage),
    fork(chatModal),
    fork(tagging),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/index.js